import { ClientLayerError } from 'shared/errors/clientLayerError'

export class NoNextPageError extends ClientLayerError {
  static readonly className: string = 'NoNextPageError'

  constructor() {
    super(`Next page is requested when it does not exist`)
    this.setMarkupOptions({ scope: 'analytics', section: null })
    this.addFingerprintSegment('no-next-page-error')
  }
}
